import React from 'react';
import { connect } from 'react-redux';

const Container = ({ children, alert }) => {
  return <div className="container mt-4">
    {alert.message &&
      <div className={`alert ${alert.type}`}>{alert.message}</div>
    }

    {children}
  </div>
}

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
}

export default connect(mapStateToProps)(Container);
